import { AfterViewInit, Component } from "@angular/core";
import { NotificacaoService } from "./notificacao.service";

@Component({
    selector: 'ui-notificacao',
    templateUrl: './notificacao.component.html',
    styleUrls: ['./notificacao.component.scss'],
})

export class NotificacaoComponent implements AfterViewInit {

    constructor(public service: NotificacaoService) {
    
    }
    
    ngAfterViewInit(): void {
        this.service.obterPendentes();
    }
}


